export const dataHooks = {
  categoryButton: (value: string) => `category-button-${value}`,
};
